import React from "react";

import logo from "../../logo.svg";
import { prettyLabel } from "../../helpers/common";
import sitesData from "../../data/data";

function sidebar() {
  const allSites = sitesData();

  return (
    <div className="sidebar">
      <div className="sidebar-heading">
        <div className="sidebar-brand pl-2 ml-1">
          <a href="/">
            <img
              style={{ width: "80%" }}
              src={logo}
              alt="gatsby Logo"
              className="dark-mode-brighten-1"
              id="logo"
            />
          </a>
        </div>
      </div>
      <div className="sidebar-body">
        <div className="sidebar-body-content">
          {allSites.themes.map((theme, index) => {
            const themeName = prettyLabel(theme.name);
            return (
              <div key={index}>
                <h4 className="sidebar-title">{themeName}</h4>
                <ul className="nav">
                  <li data-tooltip="Theme Information">
                    <a href={`/theme-info/${theme.id}`}>
                      <i className="uil uil-info-circle"></i>
                      <span className="title"><b>{`${themeName} info`}</b></span>
                      <i className="uil uil-angle-right"></i>
                    </a>
                  </li>
                  {theme.sites.map((site, index) => {
                    return (
                      <li key={index} data-tooltip={site.name}>
                        <a href={`/site-info/${site.id}`}>
                          <i className="uil uil-window"></i>
                          <span className="title">{site.name}</span>
                          <i className="uil uil-angle-right"></i>
                        </a>
                      </li>
                    );
                  })}
                </ul>
              </div>
            );
          })}

          <hr />
        </div>
      </div>
    </div>
  );
}

export default sidebar;
